<template>
  <div>
    <div class="loading" v-if="loading">
      <van-loading size="32px" type="spinner" color="#fff" vertical
        >加载中...</van-loading
      >
    </div>
    <div class="registor-page">
      <!-- 花朵装饰 -->
      <div class="snowflake snowflake-1">🌸</div>
      <div class="snowflake snowflake-2">🌺</div>
      <div class="snowflake snowflake-3">🌸</div>
      <div class="snowflake snowflake-4">🌻</div>
      <div class="snowflake snowflake-5">🌸</div>
      <div class="snowflake snowflake-6">🌺</div>
      
      <div class="login-box">
        <div class="box-title">
          <div>注册</div>
          <div style="font-size: 16px">REGISTER</div>
        </div>
        <div>
          <div class="input-box">
            <input
              class="input"
              type="text"
              v-model="form.loginName"
              placeholder="登录手机号"
            />
          </div>


          <div class="input-box">
            <input
              class="input"
              :type="pwdView ? 'text' : 'password'"
              v-model="form.loginPwd"
              placeholder="请输入密码"
            />
            <img
              @click="pwdView = !pwdView"
              v-if="!pwdView"
              src="../assets/eye.png"
              class="eye-icon"
            />
            <img
              @click="pwdView = !pwdView"
              v-else
              src="../assets/eye-close.png"
              class="eye-icon"
            />
          </div>
          <div class="input-box">
            <input
              class="input"
              :type="repwdView ? 'text' : 'password'"
              v-model="form.reLoginPwd"
              placeholder="再次输入密码"
            />
            <img
              @click="repwdView = !repwdView"
              v-if="!repwdView"
              src="../assets/eye.png"
              class="eye-icon"
            />
            <img
              @click="repwdView = !repwdView"
              v-else
              src="../assets/eye-close.png"
              class="eye-icon"
            />
          </div>
          <div class="tips">
            注：密码为8-20位数字或字母，且至少包含一个数字一个字母
          </div>
<!--          <div class="input-box">-->
<!--            <input-->
<!--                class="input"-->
<!--                type="text"-->
<!--                v-model="form.lawUserPno"-->
<!--                placeholder="推荐人用户编号"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="input-box">-->
<!--            <input-->
<!--                class="input"-->
<!--                type="text"-->
<!--                v-model="form.userPno"-->
<!--                placeholder="推荐人用户编号"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="input-box">-->
<!--            <input-->
<!--              class="input"-->
<!--              type="text"-->
<!--              v-model="form.endStr"-->
<!--              placeholder="后缀(可不填)"-->
<!--            />-->
<!--          </div>-->
          <van-checkbox
            v-model="checked"
            checked-color="#e83828"
            style="margin-top: 32px"
          >
            <div>
              我已阅读并同意<span
                style="color: #046df3"
                @click="$router.push('/userAgreement')"
                >《用户协议》</span
              >
            </div>
          </van-checkbox>
          <div class="btn" @click="register">注册</div>
        </div>
          <div class="tool-box">
            <div class="tool" @click="goToLogin">
              已有账号？去登录
            </div>
          </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <div>
          <van-loading type="spinner" color="#fff" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { service } from "../utils/request";
import { Dialog } from "vant";
import { Overlay } from "vant";
export default {
  name: "App",
  components: {
    vanOverlay: Overlay,
  },
  data() {
    return {
      loading: false,
      phoneReg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      pwdReg: /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,20}$/,
      form: {
        loginName: "",
        endStr: "",
        smsCheckCode: "1111",
      },

      pwdView: false,
      repwdView: false,
      checked: false,
      show: false,
    };
  },
  mounted() {
    this.userPid = this.getQueryString("userPid") || "";
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },


    async register() {
      if (!this.checked) {
        return Dialog({ message: "请勾选用户协议" });
      }
      if (!this.form.loginName) {
        return Dialog({ message: "请输入手机号" });
      }
      if (!this.phoneReg.test(this.form.loginName)) {
        return Dialog({ message: "请输入正确的手机号" });
      }

      if (!this.form.loginPwd) {
        return Dialog({ message: "请输入密码" });
      }
      if (!this.pwdReg.test(this.form.loginPwd)) {
        return Dialog({ message: "密码格式有误" });
      }
      if (!this.form.reLoginPwd) {
        return Dialog({ message: "请在此输入密码" });
      }
      if (this.form.loginPwd !== this.form.reLoginPwd) {
        return Dialog({ message: "两次密码输入不一致" });
      }
      this.show = true;
      let res = await service.post("/app/register", {
        ...this.form,
        userSource: 0,
        userPid: this.userPid,
      });
      this.show = false;
      if (res.data.code === "00000") {
        Dialog({ message: "注册成功！" });
        // Dialog.confirm({
        //   title: "注册成功",
        //   message: "赶快下载app登录吧～",
        //   confirmButtonText: "去下载",
        //   cancelButtonText: "稍后",
        // })
        //   .then(() => {
        //     this.$router.push("/download");
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });
      } else {
        Dialog({ message: res.data.msg || "网络错误，请重试" });
      }
    },
    goToLogin() {
      window.open('https://h5.tygk.online/', '_blank');
    },
  },
};
</script>

<style scoped>
.loading {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 40vw;
  height: 40vw;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.registor-page {
  background: linear-gradient(180deg, #FF7A45 0%, #FF5A1F 100%);
  min-height: 100vh;
  padding-top: 80px;
  box-sizing: border-box;
  padding-bottom: 16px;
  position: relative;
  overflow: hidden;
}

.registor-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.2) 2px, transparent 2px);
  background-size: 30px 30px;
  z-index: 0;
}

.login-box {
  width: 90vw;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  margin: 0 5vw;
  border-radius: 20px;
  padding: 32px 20px 40px;
  box-sizing: border-box;
  box-shadow: 0 10px 40px rgba(255, 90, 31, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  z-index: 2;
}

.box-title {
  font-size: 32px;
  text-align: center;
  margin-bottom: 24px;
  color: #FF5A1F;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(255, 90, 31, 0.2);
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.input-box {
  height: 52px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 122, 69, 0.3);
  background: #FFFFFF;
  margin-top: 16px;
  padding: 0 24px;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.input-box:focus-within {
  border-color: #FF7A45;
  box-shadow: 0 0 0 3px rgba(255, 122, 69, 0.1);
  background: #FFFFFF;
}

.input-box .input {
  display: block;
  flex: 1;
}

.tips {
  font-size: 14px;
  color: #666;
  margin-top: 12px;
  padding: 0 16px;
}

.verify-code-btn {
  color: #FF7A45;
  min-width: 6em;
  flex-shrink: 0;
  text-align: center;
  font-weight: 500;
  transition: color 0.3s ease;
}

.btn {
  margin-top: 24px;
  background: linear-gradient(135deg, #FF7A45 0%, #FF5A1F 100%);
  color: #fff;
  text-align: center;
  line-height: 52px;
  border-radius: 26px;
  font-weight: 600;
  box-shadow: 0 4px 16px rgba(255, 90, 31, 0.4);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 90, 31, 0.5);
}

.btn:active {
  transform: translateY(0);
}

.tool-box {
  margin-top: 12px;
  padding: 0 calc(5vw + 12px);
}

.tool {
  text-align: right;
  color: #FF7A45;
}

.enable {
  color: #FF5A1F;
  font-weight: 600;
}

.eye-icon {
  width: 16px;
  height: 16px;
}

.input {
  border: none;
  outline: none;
}
.flex-a-c {
  display: flex;
  align-items: center;
  font-size: 14px;
}

/* 雪花装饰样式 */
.snowflake {
  position: absolute;
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  animation: snowfall linear infinite;
  pointer-events: none;
  z-index: 1;
}

.snowflake-1 {
  left: 10%;
  animation-duration: 8s;
  animation-delay: 0s;
}

.snowflake-2 {
  left: 20%;
  animation-duration: 12s;
  animation-delay: 2s;
  font-size: 16px;
}

.snowflake-3 {
  left: 30%;
  animation-duration: 10s;
  animation-delay: 4s;
  font-size: 24px;
}

.snowflake-4 {
  left: 60%;
  animation-duration: 14s;
  animation-delay: 1s;
  font-size: 18px;
}

.snowflake-5 {
  left: 80%;
  animation-duration: 9s;
  animation-delay: 3s;
}

.snowflake-6 {
  left: 90%;
  animation-duration: 11s;
  animation-delay: 5s;
  font-size: 22px;
}

@keyframes snowfall {
  0% {
    top: -10%;
    transform: translateX(0px) rotate(0deg);
    opacity: 1;
  }
  100% {
    top: 110%;
    transform: translateX(100px) rotate(360deg);
    opacity: 0;
  }
}
</style>
